import EmrCheckbox from '@/screens/CreateEmr/EmrInput/EmrCheckbox';
import EmrDate from '@/screens/CreateEmr/EmrInput/EmrDate';
import EmrFile from '@/screens/CreateEmr/EmrInput/EmrFile';
import EmrInput from '@/screens/CreateEmr/EmrInput/EmrInput';
import EmrInputNumber from '@/screens/CreateEmr/EmrInput/EmrInputNumber';
import EmrLongText from '@/screens/CreateEmr/EmrInput/EmrLongText';
import EmrRadio from '@/screens/CreateEmr/EmrInput/EmrRadio';
import EmrSearch from '@/screens/CreateEmr/EmrInput/EmrSearch';
import EmrSelect from '@/screens/CreateEmr/EmrInput/EmrSelect';
import EmrTag from '@/screens/CreateEmr/EmrInput/EmrTag';
import EmrTime from '@/screens/CreateEmr/EmrInput/EmrTime';
import { Col } from 'antd';
import * as React from 'react';

export interface IFieldConditionProps {
  field: IFieldConfig;
  parentNames: any[];
  disabled?: boolean;
  isEdit?: boolean;
}

const FieldCondition: React.FC<IFieldConditionProps> = ({ disabled, field, parentNames, isEdit }) => {
  const name = (parentNames ? [...parentNames, field.key] : [field.key]).map((d) => String(d));

  const defaultProps = {
    disabled: disabled || !field?.editable,
    field: field,
    name: name,
    labelProps: {
      className: 'mb-2',
    },
  };

  if (isEdit === true && field.extra.update === false) {
    defaultProps.disabled = true;
  }

  const renderInput = () => {
    switch (field.inputType) {
      case 'selectKey':
        return <EmrSearch {...defaultProps} />;
      case 'number':
        return <EmrInputNumber {...defaultProps} />;
      case 'select':
        return <EmrSelect {...defaultProps} />;
      case 'longText':
        return <EmrLongText {...defaultProps} />;
      case 'date':
        return <EmrDate {...defaultProps} />;
      case 'time':
        return <EmrTime {...defaultProps} />;
      case 'file':
        return <EmrFile {...defaultProps} />;
      case 'tag':
        return <EmrTag {...defaultProps} />;
      case 'radio':
        return <EmrRadio {...defaultProps} />;
      case 'checkbox':
        return <EmrCheckbox {...defaultProps} />;
      default:
        return <EmrInput {...defaultProps} />;
    }
  };

  return (
    <Col
      span={(field?.extra?.width || 1) * 24}
      onDoubleClick={() => console.log('FIELD_CONFIG: ', field)}
      className="inline-block"
      style={{ width: `${field?.extra?.width ? field?.extra?.width * 100 : 100}%` }}
    >
      {renderInput()}
    </Col>
  );
};
export default FieldCondition;
